import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Password input with a show/hide visibility toggle (eye icon).
export default function PasswordInput({
    value, onChange, placeholder, testId,
    minLength, required = true, autoComplete = "current-password",
    className = "",
}) {
    const [visible, setVisible] = useState(false);
    return (
        <div className="relative">
            <input
                type={visible ? "text" : "password"}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                minLength={minLength}
                required={required}
                autoComplete={autoComplete}
                className={`${className} pr-11`}
                data-testid={testId}
            />
            <button
                type="button"
                onClick={() => setVisible((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-full text-warm-500 hover:text-warm-900 transition-colors"
                aria-label={visible ? "Hide password" : "Show password"}
                title={visible ? "Hide password" : "Show password"}
                data-testid={`${testId}-visibility-toggle`}
                tabIndex={-1}
            >
                {visible ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
        </div>
    );
}
